import PropTypes from 'prop-types';

const NewspaperSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 60}`}
      height={`${height || 60}`}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#clip0_237_16272${width + height})`}>
        <path
          d="M54.7266 22.9297H3.51562V33.4766L7.03125 51.0547V56.3281C7.03125 57.3126 7.80457 58.0859 8.78906 58.0859H58.2422C59.2267 58.0859 60 57.3126 60 56.3281V28.2031C60 25.285 57.6446 22.9297 54.7266 22.9297Z"
          fill={`url(#paint0_linear_237_16272${width + height})`}
        />
        <path
          d="M17.5889 17.7353C18.128 17.3438 18.3991 16.6813 18.2893 16.0255L17.6748 12.3314L20.3425 9.70498C20.8162 9.23811 20.9879 8.54283 20.7819 7.90943C20.5759 7.27604 20.03 6.81256 19.3709 6.71295L15.6698 6.15678L13.9944 2.80768C13.397 1.61635 11.447 1.61635 10.8496 2.80768L9.17402 6.15666L5.47301 6.71283C4.81383 6.81244 4.26797 7.27592 4.06195 7.90932C3.85594 8.54271 4.02762 9.23799 4.50141 9.70486L7.16906 12.3313L6.55453 16.0254C6.44461 16.6812 6.7159 17.3437 7.25496 17.7351C7.79051 18.1265 8.50805 18.1797 9.09855 17.8742L12.4219 16.149L15.7452 17.8742C16.3297 18.1783 17.0477 18.1304 17.5889 17.7353ZM24.7472 12.3313L24.1327 16.0254C24.0227 16.6812 24.294 17.3437 24.8331 17.7351C25.3721 18.1265 26.0897 18.1797 26.6767 17.8742L30 16.149L33.3233 17.8742C33.9079 18.1783 34.6259 18.1304 35.1669 17.7351C35.706 17.3437 35.9771 16.6812 35.8673 16.0254L35.2528 12.3313L37.9205 9.70486C38.3943 9.23799 38.5659 8.54271 38.3599 7.90932C38.1539 7.27592 37.608 6.81244 36.9489 6.71283L33.2479 6.15666L31.5724 2.80756C30.975 1.61623 29.025 1.61623 28.4276 2.80756L26.7521 6.15666L23.0511 6.71283C22.392 6.81244 21.8461 7.27592 21.6401 7.90932C21.4341 8.54271 21.6057 9.23799 22.0795 9.70486L24.7472 12.3313ZM55.938 7.90932C55.732 7.27592 55.1862 6.81244 54.527 6.71283L50.826 6.15666L49.1505 2.80756C48.5531 1.61623 46.6031 1.61623 46.0057 2.80756L44.3303 6.15666L40.6293 6.71283C39.9701 6.81244 39.4242 7.27592 39.2182 7.90932C39.0122 8.54271 39.1839 9.23799 39.6577 9.70486L42.3253 12.3313L41.7108 16.0254C41.6009 16.6812 41.8721 17.3437 42.4112 17.7351C42.9503 18.1265 43.6643 18.1797 44.2548 17.8742L47.5781 16.149L50.9014 17.8742C51.486 18.1783 52.204 18.1304 52.745 17.7351C53.2841 17.3437 53.5553 16.6812 53.4455 16.0254L52.8309 12.3313L55.4986 9.70486C55.9724 9.23799 56.1441 8.54271 55.938 7.90932ZM51.2109 29.961H15.8203C14.8487 29.961 14.0625 30.7472 14.0625 31.7188V42.2656C14.0625 43.2372 14.8487 44.0235 15.8203 44.0235H51.2109C52.1825 44.0235 52.9688 43.2372 52.9688 42.2656V31.7188C52.9688 30.7472 52.1825 29.961 51.2109 29.961ZM29.8828 47.5391H15.8203C14.8487 47.5391 14.0625 48.3253 14.0625 49.2969C14.0625 50.2685 14.8487 51.0547 15.8203 51.0547H29.8828C30.8544 51.0547 31.6406 50.2685 31.6406 49.2969C31.6406 48.3253 30.8544 47.5391 29.8828 47.5391ZM51.2109 47.5391H37.1484C36.1768 47.5391 35.3906 48.3253 35.3906 49.2969C35.3906 50.2685 36.1768 51.0547 37.1484 51.0547H51.2109C52.1825 51.0547 52.9688 50.2685 52.9688 49.2969C52.9688 48.3253 52.1825 47.5391 51.2109 47.5391ZM3.51562 22.9297C1.68187 22.9297 0 24.4063 0 26.4453V47.5391C0 49.4808 1.57395 51.0547 3.51562 51.0547H7.03125V26.4453C7.03125 24.5117 5.44922 22.9297 3.51562 22.9297Z"
          fill={`url(#paint1_linear_237_16272${width + height})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_237_16272${width + height}`}
          x1="31.7578"
          y1="58.0859"
          x2="31.7578"
          y2="22.9297"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_237_16272${width + height}`}
          x1="28.012"
          y1="51.0547"
          x2="28.012"
          y2="1.91406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <clipPath id={`clip0_237_16272${width + height}`}>
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

NewspaperSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default NewspaperSvg;
